import React, { useContext } from 'react';
import { Helmet } from 'react-helmet-async';
import { ThemeContext } from '../../context/ThemeContext';
import { getContrastColor } from '../../utils/colorUtils';
import { PageWrapper, Container, PageTitle, Section, SectionTitle, TipList, TipItem } from './Consejos.styles';

export default function Consejos() {
  const { theme } = useContext(ThemeContext);
  const bg  = theme.background || '#000';
  const acc = theme.accent     || '#667eea';
  const txt = getContrastColor(bg);

  return (
    <PageWrapper bg={bg}>
      <Helmet>
        <title>Consejos de seguridad · Trastero</title>
        <meta name="description" content="Consejos para comprar y vender de forma segura en Trastero. Protégete de fraudes y transacciones seguras." />
      </Helmet>
      <Container>
        <PageTitle color={txt}>Consejos de seguridad</PageTitle>

        <Section>
          <SectionTitle accent={acc}>Para compradores</SectionTitle>
          <TipList>
            <TipItem color={txt}>✅ Verifica la identidad del vendedor antes de hacer ningún pago.</TipItem>
            <TipItem color={txt}>✅ Inspecciona el artículo en persona siempre que sea posible antes de pagarlo.</TipItem>
            <TipItem color={txt}>✅ Queda en un lugar público y concurrido para realizar el intercambio.</TipItem>
            <TipItem color={txt}>✅ Si pagas online, usa métodos con protección al comprador (Bizum entre conocidos, transferencia solo si confías).</TipItem>
            <TipItem color={txt}>⚠️ Desconfía de precios muy por debajo del valor de mercado.</TipItem>
            <TipItem color={txt}>⚠️ No realices pagos anticipados a desconocidos sin haber visto el artículo.</TipItem>
            <TipItem color={txt}>⚠️ No compartas datos personales innecesarios (DNI, cuenta bancaria) sin necesidad real.</TipItem>
          </TipList>
        </Section>

        <Section>
          <SectionTitle accent={acc}>Para vendedores</SectionTitle>
          <TipList>
            <TipItem color={txt}>✅ Verifica que el pago se ha completado antes de entregar el artículo.</TipItem>
            <TipItem color={txt}>✅ Queda en un lugar público para realizar el intercambio.</TipItem>
            <TipItem color={txt}>✅ Usa fotos reales del artículo para evitar malentendidos.</TipItem>
            <TipItem color={txt}>⚠️ Desconfía de compradores que proponen métodos de pago inusuales o que piden datos bancarios.</TipItem>
            <TipItem color={txt}>⚠️ No aceptes pagos por importes superiores al precio acordado con solicitud de devolución de diferencia.</TipItem>
          </TipList>
        </Section>

        <Section>
          <SectionTitle accent={acc}>Reportar comportamientos sospechosos</SectionTitle>
          <TipList>
            <TipItem color={txt}>Si detectas un anuncio fraudulento, usa el botón de reporte en la imagen del artículo.</TipItem>
            <TipItem color={txt}>Para incidencias graves o urgentes escríbenos a abuse@trasteroweb.es.</TipItem>
          </TipList>
        </Section>
      </Container>
    </PageWrapper>
  );
}
